var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { computed, ref, set } from "vue";
import { getCompositeDatasetLink } from "@/api/datasets";
import { useDatasetExtraFilesStore } from "@/stores/datasetExtraFilesStore";
export function useDatasetPathDestination() {
    const datasetExtraFilesStore = useDatasetExtraFilesStore();
    const cache = ref({});
    const datasetPathDestination = computed(() => {
        return (dataset_id, path) => {
            var _a;
            const targetPath = path !== null && path !== void 0 ? path : "undefined";
            const pathDestination = (_a = cache.value[dataset_id]) === null || _a === void 0 ? void 0 : _a[targetPath];
            if (!pathDestination) {
                getPathDestination(dataset_id, path);
            }
            return pathDestination !== null && pathDestination !== void 0 ? pathDestination : null;
        };
    });
    function getPathDestination(dataset_id, path) {
        return __awaiter(this, void 0, void 0, function* () {
            let datasetExtraFiles = datasetExtraFilesStore.getDatasetExtraFiles(dataset_id);
            if (!datasetExtraFiles) {
                yield datasetExtraFilesStore.fetchDatasetExtFilesByDatasetId({ id: dataset_id });
                datasetExtraFiles = datasetExtraFilesStore.getDatasetExtraFiles(dataset_id);
            }
            if (datasetExtraFiles === null) {
                return null;
            }
            const pathDestination = {
                datasetContent: datasetExtraFiles,
                isDirectory: false,
                filepath: path,
            };
            if (path === undefined || path === "undefined") {
                set(cache.value, dataset_id, { ["undefined"]: pathDestination });
                return pathDestination;
            }
            const filepath = path;
            const datasetEntry = datasetExtraFiles === null || datasetExtraFiles === void 0 ? void 0 : datasetExtraFiles.find((entry) => {
                return filepath === entry.path;
            });
            if (datasetEntry) {
                if (datasetEntry.class === "Directory") {
                    pathDestination.isDirectory = true;
                    pathDestination.filepath = filepath;
                    return pathDestination;
                }
                pathDestination.fileLink = getCompositeDatasetLink(dataset_id, datasetEntry.path);
            }
            set(cache.value, dataset_id, { [path]: pathDestination });
            return pathDestination;
        });
    }
    return { datasetPathDestination };
}
